/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetConsigneeTours } from '../../models/get-consignee-tours';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeTours$Params {
  organizationSiteKey: KeyType;
}

export function getConsigneeTours(http: HttpClient, rootUrl: string, params: GetConsigneeTours$Params, context?: HttpContext): Observable<StrictHttpResponse<GetConsigneeTours>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeTours.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetConsigneeTours>;
    })
  );
}

getConsigneeTours.PATH = '/organization-sites/{organizationSiteKey}/consignee/tours';
